
var helper = require('../helper');

function Overlay() {
    this.$overlay = $('.nice-big-dark-overlay');
    this.$message = this.$overlay.find('.message');
    this.$body = $('body');
    var self = this; // Needed for using all constructor variables inside this function, note the differece -> no "this" but "var" at the beginning
}

Overlay.prototype.showOverlay = function(message) {
    var self = this;
    if (message) {
        self.$body.css('position', 'relative');
        self.$message.html(message);
        self.$body.animate({ scrollTop: 0 }, 'fast');
    }
    self.$overlay.fadeIn('fast');
}

module.exports = Overlay;